import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_POST } from "../General/Utility";
import { Show_Message } from "../General/Messagedialogbox";

function MasterCodeSetting(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const [isAutoNo, setisAutoNo] = useState(false);
  const [strCodeFormat, setstrCodeFormat] = useState("");
  const [iNextNo, setiNextNo] = useState(0);
  const [iMaxDegit, setiMaxDegit] = useState(0);
  const [strCode, setstrCode] = useState("");
  const [isChanged, setisChanged] = useState(false);

  useEffect(() => {
    Load_MaterCode(); // Update Master Code if Auto Generated True
  }, []);

  useEffect(() => {
    if (isAutoNo) View_MaterCode(); // Update Master Code if Auto Generated True
    else {
      setstrCode("");
      setstrCodeFormat("");
      setiNextNo(0);
      setiMaxDegit(0);
    }
  }, [isAutoNo]);

  const Load_MaterCode = async () => {
    try {
      const res = await API_POST(
        "ConfigurationSetting/View_MasterCode",
        {
          iScrId: props.iScrId,
          iBranchId: Number(_AuthParems.Branch),
          strDBName: _AuthParems.DB,
        },
        dispatch
      );
      if (res) {
        let VouchNo = res.EntCode[0];
        setisAutoNo(!VouchNo.isManualNumber);
        if (!VouchNo.isManualNumber) {
          setstrCode(VouchNo.code);
          setstrCodeFormat(VouchNo.codeFormat);
          setiNextNo(VouchNo.nextNumber);
          setiMaxDegit(VouchNo.numSeqMaxDigit);
        }
      }
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    }
  };
  const View_MaterCode = async () => {
    try {
      const res = await API_POST(
        "ConfigurationSetting/View_MasterCode",
        {
          iScrId: props.iScrId,
          iBranchId: Number(_AuthParems.Branch),
          strDBName: _AuthParems.DB,
        },
        dispatch
      );
      if (res) {
        let VouchNo = res.EntCode[0];
        setstrCode(VouchNo.code);
        setstrCodeFormat(VouchNo.codeFormat);
        setiNextNo(VouchNo.nextNumber);
        setiMaxDegit(VouchNo.numSeqMaxDigit);
      }
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    }
  };
  const Update_MasterCode = async () => {
    try {
      if (isAutoNo && !strCodeFormat.includes("#N"))
        Show_Message(dispatch, "#N is Mandatory", "info");
      else {
        const res = await API_POST(
          "ConfigurationSetting/Update_MasterCode/",
          {
            NumSeqMaxDigit: iMaxDegit,
            NextNumber: iNextNo,
            CodeFormat: strCodeFormat,
            ScrId: props.iScrId,
            strDBName: _AuthParems.DB,
            IsManualNumber: !isAutoNo,
            iBranchId: Number(_AuthParems.Branch),
          },
          dispatch
        );
        if (res) {
          Load_MaterCode();
          Show_Message(dispatch, res.strMessage, "success");
          setisChanged(true);
        }
      }
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    }
  };
  return (
    <div className="popup-container">
      <div className="popup-content config-popup">
        <div className="popup-header">
          <h5>Configure Master Code</h5>
          <div className="icon-popup-btn-grp">
            <span
              className="icon-btn"
              onClick={(e) => {
                if (isChanged) window.location.reload();
                else props.Close();
              }}
            >
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="row">
            <p className="config-text">
              {!isAutoNo &&
                `Your Master Code are set on auto-generate mode to save your time.Are you sure about changing this setting?`}
              {isAutoNo &&
                "You have selected manual Master Code.Do you want us to auto-generate it for you?"}
            </p>
            {isAutoNo && (
              <p className="config-text1">
                <strong>#P-Prefix</strong>
                <strong>#N-No</strong>
              </p>
            )}
            <div className="row">
              <div className="col-sm-12 col-md-12">
                <div className="inv-check">
                  <input
                    type="checkbox"
                    checked={isAutoNo}
                    onChange={(e) => {
                      setisAutoNo(!isAutoNo);
                    }}
                  />
                  <label style={{ fontWeight: isAutoNo ? "bold" : "normal" }}>
                    Continue auto-generating Master Code
                  </label>
                </div>
              </div>
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Max Degit</label>
                  <input
                    type="number"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={iMaxDegit}
                    onChange={(e) => setiMaxDegit(e.target.value)}
                    placeholder="0"
                    onClick={(e) => e.target.select()}
                  />
                </div>
              )}
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Next No</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={iNextNo}
                    placeholder="000"
                    onChange={(e) => setiNextNo(e.target.value)}
                    onClick={(e) => e.target.select()}
                  />
                </div>
              )}
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Code Formate</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={strCodeFormat}
                    onChange={(e) => setstrCodeFormat(e.target.value)}
                    placeholder="Inv-"
                    onClick={(e) => e.target.select()}
                  />
                </div>
              )}
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Inv No</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={strCode}
                    readOnly
                  />
                </div>
              )}
              <div className="col-sm-12 col-md-12 ">
                <div className="inv-check">
                  <input
                    type="checkbox"
                    checked={!isAutoNo}
                    onChange={(e) => setisAutoNo(!isAutoNo)}
                  />
                  <label style={{ fontWeight: !isAutoNo ? "bold" : "normal" }}>
                    Enter Master Code Manually
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            <button
              className="btn-fabgreen"
              onClick={(e) => Update_MasterCode()}
            >
              Save&nbsp; <i className="bx bxs-save"></i>
            </button>
            <button className="btn-fabgreen" onClick={props.Close}>
              Cancel&nbsp; <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MasterCodeSetting;
